export const COMPONENTS = {
    V: 'V',
    S: 'S',
    M: 'M',
    G: 'M (gp)',
    C: 'M (consumed)'
};